import { GeneroEnum, obtenerIdGenero } from "../shared/enums/Genero.enum";
import { obtenerIdRangoEdad, obtenerIdsRangoEdad, RangosEdadEnum } from "../shared/enums/RangoEdad.enum";
import { CiudadDTO } from "./Ciudad.DTO";
import { PaisDTO } from "./Pais.DTO";
import { RegionDTO } from "./Region.DTO";
import { Nilable } from "../shared/utils/Nullable";
import { CoordenadasDTO, ICoordenadasDTO } from "./Coordenadas.DTO";

export interface IRespuestaUsuario {
    answers: [number, Nilable<string>, Nilable<number>][];
    id: number;
    country: Nilable<string>;
    age_range: Nilable<string>;
    gender: Nilable<string>;
    region: Nilable<string>;
    city: Nilable<string>;
    location: ICoordenadasDTO;
}

export class RespuestaUsuario {
    public respuestas: [number, Nilable<string>, Nilable<number>][] = [];
    public id = 0;
    public pais: Nilable<PaisDTO>;
    public rangoEdad: Nilable<RangosEdadEnum>;
    public genero: Nilable<GeneroEnum>;
    public region: Nilable<RegionDTO>;
    public ciudad: Nilable<CiudadDTO>;
    public coordenadas = new CoordenadasDTO();

    constructor(json: Nilable<Partial<IRespuestaUsuario>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IRespuestaUsuario>) {
        if (json.answers != null) {
            this.respuestas = json.answers;
        }
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.country != null) {
            this.pais = new PaisDTO({ code: json.country });
        }
        if (json.age_range != null) {
            const rango = obtenerIdsRangoEdad().find(([, id]) =>
                id === json.age_range);
            if (rango != null) {
                this.rangoEdad = rango[0];
            }
        }
        if (json.gender != null) {
            this.genero = GeneroEnum[json.gender];
        }
        if (json.region != null) {
            this.region = new RegionDTO({ name: json.region });
        }
        if (json.city != null) {
            this.ciudad = new CiudadDTO({ name: json.city });
        }
        if (json.location != null) {
            this.coordenadas = new CoordenadasDTO(json.location);
        }
    }

    public toJSON(): IRespuestaUsuario {
        return {
            answers: this.respuestas,
            id: this.id,
            country: this.pais?.codigo ?? null,
            age_range: this.rangoEdad != null ? obtenerIdRangoEdad(this.rangoEdad) : null,
            gender: this.genero != null ? obtenerIdGenero(this.genero) : null,
            region: this.region?.nombre ?? null,
            city: this.ciudad?.nombre ?? null,
            location: this.coordenadas.toJSON()
        };
    }
}
